import React from 'react'
import { Link } from 'react-router-dom'

 function ReadOnlyDeals ({deal,handleEditClick,handleDeleteClick,handlesubdealClick})  {

  
  return (
    
   
  //  <>
              <tr>
                    {/* old: <td>{deal.id}</td> */}
                    {/* new: show the id again so the columns match the table header ("DEAl Id" is the first column) */}
                    <td>{deal.id}</td>
                     <td>{deal.store.store}</td>
                    <td>{deal.category.category}</td>                    
                    <td>{deal.commondiscription}</td>
                   
                    <td><img src={deal.imageurl} alt="dealimage" style={{width:'100px'}}></img></td>
                    
                   {/* <td><button id={deal.id}>delete</button></td> */}
                   {/* old:
                   <td><button id='btnedit'  onClick={(event)=>handleEditClick(event,deal)}>Edit</button></td>
                    <Link to="/user/dashboard" onClick={(event)=>handleDeleteClick(event,deal)}>Delete</Link>
                    <Link to={'/user/editsubdeals/'+deal.id}>subDeal</Link>
                   */}
                   {/* <td><button id='btndelete' onClick={(event)=>handleDeleteClick(event,deal)}>Delete</button></td>  */}
                    {/* <Link to={'/dealdetail/' + deal.id} >SubDeal</Link>              */}
                   {/* new: all actions inside ONE table cell. Links outside a <td> get moved by the browser
                       and end up next to the wrong deal (that's why sub-deals looked mixed up) */}
                   <td>
                     <button id='btnedit'  onClick={(event)=>handleEditClick(event,deal)}>Edit</button>
                     {' '}
                     <Link to="/user/dashboard" onClick={(event)=>handleDeleteClick(event,deal)}>Delete</Link>
                     {' '}
                     <Link to={'/user/editsubdeals/'+deal.id}>subDeal</Link>
                   </td>
                    
                </tr>
              
               
   
   
                
       
  )
}
export default ReadOnlyDeals;
